import styled from 'styled-components';

export const StyledTimer = styled.span`
    margin-left: 8px;

    @media screen and (max-width: 375px) {
        display: none;
    }
`;
